import { Dialog, DialogContent, DialogHeader, DialogTrigger } from '@/components/ui/dialog';

export default function VideoPopup({ url, label }: { url: string; label: string }) {
  return (
    <Dialog>
      <DialogTrigger className='py-2 px-5 mx-auto flex justify-center text-[#35D461] border border-[#35D461] bg-white rounded-md '>{label}</DialogTrigger>
      <DialogContent className='dialog-box max-w-5xl w-full p-4 border-none [&_button]:-top-4 [&_button]:-right-4 [&_button>svg]:h-5 [&_button>svg]:w-5 [&_button]:bg-white [&_button]:rounded-full [&_button]:shadow-md [&_button]:w-8 [&_button]:h-8 [&_button]:flex [&_button]:justify-center [&_button]:items-center'>
        <DialogHeader>
          <div className='w-full rounded-sm'>
            <iframe
              className='w-full aspect-video rounded-sm border-0'
              width='100%'
              src={url}
              title='YouTube video player'
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
              referrerPolicy='strict-origin-when-cross-origin'
              allowFullScreen
            ></iframe>
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
